<script setup>
import { defineProps, computed } from 'vue';
const props = defineProps({
  width: {
    type: [String, Number],
    default: 16,
  },
  height: {
    type: [String, Number],
    default: 16,
  },
  ariaLabel: {
    type: String,
    default: 'Success icon',
  },
  variant: {
    type: String,
    default: 'bordered',
  },
});

const VARIANTS = {
  blue: {
    style: '',
    color: '#0070F2'
  },
  gray: {
    style: '',
    color: '#223548'
  },
  bordered: {
    style: 'rounded-md border-solid border border-[#188918] bg-[#F5FAE5]',
    color: '#256F3A'
  }
};

const variantConfig = computed(() => VARIANTS[props.variant]);
const styles = computed(() => variantConfig.value.style);
const fillColor = computed(() => variantConfig.value.color);
</script>

<template>
  <div
     class="icon-container flex items-center justify-center"
    :class="styles"
    :style="{
      width: props.width + 'px',
      height: props.height + 'px',
    }"
    role="img"
    :aria-label="ariaLabel"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      automation-id="success-icon"
      aria-hidden="true"
      focusable="false"
    >
      <title>Success check mark</title>
      <path
        :fill="fillColor"
        d="M5.813 12.5a.723.723 0 0 1-.532-.219L2.25 9.375A.777.777 0 0 1 2 8.812c0-.229.073-.416.219-.562A.811.811 0 0 1 2.813 8c.166 0 .343.073.53.219l2.47 2.375 6.812-6.844a.777.777 0 0 1 .563-.25c.208 0 .395.083.562.25.167.167.25.354.25.563 0 .229-.073.416-.219.562l-7.375 7.406c-.146.146-.343.219-.593.219Z"
      />
    </svg>
  </div>
</template>
